import { chain, keyBy, map, pickBy } from 'lodash';
import sdk from '../../qoc-sdk';

export const types = {
  ON_DELETE_INSTANCE_LINKS_FULFILLED: 'ON_DELETE_INSTANCE_LINKS_FULFILLED',
  ON_DELETE_INSTANCE_LINKS_PENDING: 'ON_DELETE_INSTANCE_LINKS_PENDING',
  ON_DELETE_INSTANCE_LINKS_REJECTED: 'ON_DELETE_INSTANCE_LINKS_REJECTED',

  ON_DELETE_INSTANCES_RESPONSES_FULFILLED:
    'ON_DELETE_INSTANCES_RESPONSES_FULFILLED',
  ON_DELETE_INSTANCES_RESPONSES_PENDING:
    'ON_DELETE_INSTANCES_RESPONSES_PENDING',
  ON_DELETE_INSTANCES_RESPONSES_REJECTED:
    'ON_DELETE_INSTANCES_RESPONSES_REJECTED',

  ON_INITIALIZE_CACHE_FULFILLED: 'ON_INITIALIZE_CACHE_FULFILLED',
  ON_INITIALIZE_CACHE_PENDING: 'ON_INITIALIZE_CACHE',
  ON_INITIALIZE_CACHE_REJECTED: 'ON_INITIALIZE_CACHE_REJECTED',

  ON_FETCH_INSTANCE_LINKS_FULFILLED: 'ON_FETCH_INSTANCE_LINKS_FULFILLED',
  ON_FETCH_INSTANCE_LINKS_PENDING: 'ON_FETCH_INSTANCE_LINKS_PENDING',
  ON_FETCH_INSTANCE_LINKS_REJECTED: 'ON_FETCH_INSTANCE_LINKS_REJECTED',

  ON_FETCH_INSTANCES_FULFILLED: 'ON_FETCH_INSTANCES_FULFILLED',
  ON_FETCH_INSTANCES_PENDING: 'ON_FETCH_INSTANCES_PENDING',
  ON_FETCH_INSTANCES_REJECTED: 'ON_FETCH_INSTANCES_REJECTED',

  ON_FETCH_INSTANCES_QUESTIONS_FULFILLED:
    'ON_FETCH_INSTANCES_QUESTIONS_FULFILLED',
  ON_FETCH_INSTANCES_QUESTIONS_PENDING: 'ON_FETCH_INSTANCES_QUESTIONS_PENDING',
  ON_FETCH_INSTANCES_QUESTIONS_REJECTED:
    'ON_FETCH_INSTANCES_QUESTIONS_REJECTED',

  ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_FULFILLED:
    'ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_FULFILLED',
  ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_PENDING:
    'ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_PENDING',
  ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_REJECTED:
    'ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_REJECTED',

  ON_FETCH_INSTANCES_RESPONSES_FULFILLED:
    'ON_FETCH_INSTANCES_RESPONSES_FULFILLED',
  ON_FETCH_INSTANCES_RESPONSES_PENDING: 'ON_FETCH_INSTANCES_RESPONSES_PENDING',
  ON_FETCH_INSTANCES_RESPONSES_REJECTED:
    'ON_FETCH_INSTANCES_RESPONSES_REJECTED',

  ON_POST_INSTANCES_RESPONSES_FULFILLED:
    'ON_POST_INSTANCES_RESPONSES_FULFILLED',
  ON_POST_INSTANCES_RESPONSES_PENDING: 'ON_POST_INSTANCES_RESPONSES_PENDING',
  ON_POST_INSTANCES_RESPONSES_REJECTED: 'ON_POST_INSTANCES_RESPONSES_REJECTED',

  ON_POST_INSTANCE_LINKS_FULFILLED: 'ON_POST_INSTANCE_LINKS_FULFILLED',
  ON_POST_INSTANCE_LINKS_PENDING: 'ON_POST_INSTANCE_LINKS_PENDING',
  ON_POST_INSTANCE_LINKS_REJECTED: 'ON_POST_INSTANCE_LINKS_REJECTED'
};

/**
 * Fetch Instances Questions Options
 */
const onFetchInstancesQuestionsOptionsFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchInstancesQuestionsOptionsRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchInstancesQuestionsOptions = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_INSTANCES_QUESTIONS_OPTIONS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getInstancesQuestionsOptions(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200 || status === 404) {
        return dispatch(
          onFetchInstancesQuestionsOptionsFulFilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            options: keyBy(data.responseEntity, 'optionUUID'),
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200 or 404'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchInstancesQuestionsOptionsRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Fetch Instances Questions
 */
const onFetchInstancesQuestionsFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_QUESTIONS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchInstancesQuestionsRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_QUESTIONS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchInstancesQuestions = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_INSTANCES_QUESTIONS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getInstancesQuestions(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200 || status === 404) {
        return dispatch(
          onFetchInstancesQuestionsFulFilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            questions: keyBy(data.responseEntity, 'questionUUID'),
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200 or 404'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchInstancesQuestionsRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Fetch Instances Responses
 */
const onFetchInstancesResponsesFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_RESPONSES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchInstancesResponsesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_RESPONSES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchInstancesResponses = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_INSTANCES_RESPONSES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getInstancesResponses(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200 || status === 404) {
        return dispatch(
          onFetchInstancesResponsesFulFilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            responses: keyBy(data.responseEntity, 'surveyResponseUUID'),
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200 or 404'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchInstancesResponsesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Delete Responses
 */
const onDeleteInstancesSurveyResponsesFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_DELETE_INSTANCES_RESPONSES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onDeleteInstancesSurveyResponsesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_DELETE_INSTANCES_RESPONSES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onDeleteInstancesSurveyResponses = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_DELETE_INSTANCES_RESPONSES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;
  const { surveyResponseUUID, surveyResponseUUIDs } = requestProps;

  return sdk
    .deleteInstancesSurveysResponses(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onDeleteInstancesSurveyResponsesFulFilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            status,
            surveyResponseUUIDs: surveyResponseUUIDs || [surveyResponseUUID]
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onDeleteInstancesSurveyResponsesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Post Responses
 */
const onPostInstancesResponsesFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_POST_INSTANCES_RESPONSES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onPostInstancesResponsesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_POST_INSTANCES_RESPONSES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onPostInstancesResponses = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_POST_INSTANCES_RESPONSES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;
  const { surveyResponses, ...otherRequestProps } = requestProps;

  const surveyResponsesNew = chain(surveyResponses)
    .filter(surveyResponse => surveyResponse.value !== null)
    .map(surveyResponse => {
      const {
        responseDataType,
        value,
        ...otherSurveyResponseProps
      } = surveyResponse;

      const responseKey = sdk.utils.getResponseKey({ responseDataType });

      const surveyResponseClean = pickBy(
        {
          recordChangeDateTime: new Date().getTime(),
          responseDataType,
          [responseKey]: value,
          ...otherSurveyResponseProps
        },
        property => typeof property !== 'undefined'
      );

      return Object.assign({}, surveyResponseClean);
    })
    .value();

  return sdk
    .postPutSurveyResponsesNoCache({
      ...otherRequestProps,
      surveyResponses: surveyResponsesNew
    })
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 201) {
        const surveyResponsesWithUUIDs = chain(surveyResponsesNew)
          .map((surveyResponse, index) =>
            Object.assign({}, surveyResponse, {
              surveyResponseUUID: data[index].id
            })
          )
          .value();

        return dispatch(
          onPostInstancesResponsesFulFilled({
            fulfillCallback,
            message: fulfillMessage || statusText,
            responses: keyBy(surveyResponsesWithUUIDs, 'surveyResponseUUID'),
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 201'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onPostInstancesResponsesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Fetch Instances
 */
const onFetchInstancesFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchInstancesRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCES_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchInstances = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_INSTANCES_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getInstances(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200 || status === 404) {
        return dispatch(
          onFetchInstancesFulFilled({
            instances: keyBy(data.responseEntity, 'instanceUUID'),
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200 or 404'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchInstancesRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Fetch InstanceLinks
 */
const onFetchInstanceLinksFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCE_LINKS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onFetchInstanceLinksRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_FETCH_INSTANCE_LINKS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onFetchInstanceLinks = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_FETCH_INSTANCE_LINKS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;

  return sdk
    .getInstanceLinks(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (status === 200 || status === 404) {
        return dispatch(
          onFetchInstanceLinksFulfilled({
            instanceLinks: keyBy(data.responseEntity, 'instanceLinkUUID'),
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200 or 404'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onFetchInstanceLinksRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Delete InstanceLinks
 */
const onDeleteInstanceLinksFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_DELETE_INSTANCE_LINKS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onDeleteInstanceLinksRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_DELETE_INSTANCE_LINKS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onDeleteInstanceLinks = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_DELETE_INSTANCE_LINKS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;
  const { instanceLinkUUID, instanceLinkUUIDs } = requestProps;

  return sdk
    .deleteInstanceLinks(requestProps)
    .then(response => {
      const { status, statusText } = response;

      if (status === 200) {
        return dispatch(
          onDeleteInstanceLinksFulFilled({
            instanceLinkUUIDs: instanceLinkUUIDs || [instanceLinkUUID],
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 200'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onDeleteInstanceLinksRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Post InstanceLinks
 */
const onPostInstanceLinksFulFilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_POST_INSTANCE_LINKS_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onPostInstanceLinksRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_POST_INSTANCE_LINKS_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onPostInstanceLinks = (props = {}) => dispatch => {
  dispatch({
    type: types.ON_POST_INSTANCE_LINKS_PENDING
  });

  const {
    requestProps = {},
    fulfillCallback,
    fulfillMessage,
    rejectCallback,
    rejectMessage
  } = props;
  const { instanceLinksToCreate, method } = requestProps;

  return sdk
    .postPutInstanceLinks(requestProps)
    .then(response => {
      const { data, status, statusText } = response;

      if (
        status === 201 ||
        (method === 'put' && status === 200) ||
        status === 200
      ) {
        const instanceLinks =
          method !== 'put'
            ? chain(instanceLinksToCreate)
                .map((instanceLink, index) =>
                  Object.assign({}, instanceLink, {
                    instanceLinkUUID: data.responseEntity[index].id
                  })
                )
                .value()
            : instanceLinksToCreate;

        return dispatch(
          onPostInstanceLinksFulFilled({
            instanceLinks: instanceLinks[0].instanceLinkUUID,
            fulfillCallback,
            message: fulfillMessage || statusText,
            status
          })
        );
      }

      return Promise.reject(new Error('Status not 201'));
    })
    .catch(error => {
      const { response = {}, message } = error;

      return dispatch(
        onPostInstanceLinksRejected({
          rejectCallback,
          message: rejectMessage || response.statusText || message,
          status: response.status || -1
        })
      );
    });
};

/**
 * Fetch InstanceLinks and Survey Responses
 */
export const onFetchInstanceLinksWithInstancesResponses = (
  props = {}
) => dispatch => {
  const {
    targetInstanceLinkResponses = true,
    instanceLinksRequestProps = {},
    instancesResponsesRequestProps = {}
  } = props;

  if (targetInstanceLinkResponses) {
    return dispatch(onFetchInstanceLinks(instanceLinksRequestProps)).then(
      ({ instanceLinks }) => {
        const instanceLinkUUIDs = map(instanceLinks, 'instanceLinkUUID');

        return dispatch(
          onFetchInstancesResponses({
            instanceLinkUUIDs,
            ...instancesResponsesRequestProps
          })
        );
      }
    );
  }

  return dispatch(onFetchInstanceLinks(instanceLinksRequestProps)).then(() =>
    dispatch(onFetchInstancesResponses(instancesResponsesRequestProps))
  );
};

/**
 * Initialize Cache
 */
const onInitializeCacheFulfilled = (props = {}) => dispatch => {
  const { fulfillCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_CACHE_FULFILLED
  });

  if (typeof fulfillCallback === 'function') {
    fulfillCallback(props);
  }

  return props;
};

const onInitializeCacheRejected = (props = {}) => dispatch => {
  const { rejectCallback } = props;

  dispatch({
    data: props,
    type: types.ON_INITIALIZE_CACHE_REJECTED
  });

  if (typeof rejectCallback === 'function') {
    rejectCallback(props);
  }

  return props;
};

export const onInitializeCache = (props = {}) => (dispatch, getState) => {
  dispatch({
    type: types.ON_INITIALIZE_CACHE_PENDING
  });

  const { fulfillCallback, rejectCallback } = props;
  const errorMessage = 'Cache initialize failed';
  const successMessage = 'Cache initialize successfull';

  return Promise.all([
    dispatch(onFetchInstances()),
    dispatch(onFetchInstanceLinks()),
    dispatch(onFetchInstancesQuestions()),
    dispatch(onFetchInstancesQuestionsOptions()),
    dispatch(onFetchInstancesResponses())
  ])
    .then(() =>
      dispatch(
        onInitializeCacheFulfilled({
          cache: getState().cache,
          fulfillCallback,
          message: successMessage,
          status: 200
        })
      )
    )
    .catch(() =>
      dispatch(
        onInitializeCacheRejected({
          rejectCallback,
          message: errorMessage,
          status: 400
        })
      )
    );
};



// WEBPACK FOOTER //
// ./src/qoc-redux/Cache/actions.js